import React from 'react';

/**
 * 下注卡片正面组件
 * 显示倒计时、赔率和进度条
 */
export default function CardFront({ period, data }) {
  const getColorClasses = (minutes) => {
    if (minutes === 5) {
      return {
        label: 'bg-blue-500/30 text-blue-200',
        progress: 'bg-gradient-to-r from-blue-500 to-cyan-500'
      };
    } else if (minutes === 15) {
      return {
        label: 'bg-purple-500/30 text-purple-200',
        progress: 'bg-gradient-to-r from-purple-500 to-pink-500'
      };
    } else {
      return {
        label: 'bg-orange-500/30 text-orange-200',
        progress: 'bg-gradient-to-r from-orange-500 to-red-500'
      };
    }
  };

  const colors = getColorClasses(period.minutes);

  return (
    <div className="absolute inset-0 backface-hidden rounded-lg backdrop-blur-sm border border-white/10 shadow-md bg-[#22283a]/80">
      {/* 左上角标签 - 紧贴边框 */}
      <div className="absolute top-0 left-0 z-10">
        <div className={`px-1.5 py-0.5 rounded-br text-xs font-bold ${colors.label}`}>
          {data.label}
        </div>
      </div>
      
      <div className="relative p-3 pt-5">
        {/* 竖排：倒计时 */}
        <div className="text-center mb-1">
          <div className={`font-mono text-2xl font-bold ${data.countdownColorClass}`}>
            {data.formattedTime}
          </div>
          <div className="text-xs text-white/50" style={{marginTop: -2}}>Time Left</div>
        </div>
        
        {/* AI 预测看涨/看跌对比 */}
        <div className="text-center">
          {/* 预测标题 */}
          
          {/* AI预测对比条 */}
          <div className="relative w-full h-6 bg-gray-700 rounded-lg overflow-hidden">
            {/* 看涨部分 (左侧绿色) */}
            <div 
              className="absolute left-0 top-0 h-full transition-all duration-500 ease-out"
              style={{ 
                width: `${data.aiPrediction?.bullish || 50}%`,
                background: 'rgba(34, 197, 94, 0.5)'
              }}
            />
            
            {/* 看跌部分 (右侧红色) */}
            <div 
              className="absolute right-0 top-0 h-full transition-all duration-500 ease-out"
              style={{ 
                width: `${data.aiPrediction?.bearish || 50}%`,
                background: 'rgba(239, 68, 68, 0.5)'
              }}
            />
            
            {/* 百分比显示（在进度条内部） */}
            <div className="absolute inset-0 flex items-center justify-between px-2 text-[9px] text-white font-medium">
              <span>↗ {data.aiPrediction?.bullish || 50}%</span>
              <span>↘ {data.aiPrediction?.bearish || 50}%</span>
            </div>
          </div>
          <div className="text-xs text-white/50 mt-1">AI Pred</div>
        </div>
      </div>
      
      {/* 底部进度条 */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/10">
        <div 
          className={`h-full transition-all duration-1000 ${colors.progress}`}
          style={{
            width: `${Math.max(0, Math.min(100, (data.totalSeconds / (period.minutes * 60)) * 100))}%`
          }}
        ></div>
      </div>
    </div>
  );
}
